import { useEffect, useState } from 'react';
import { apiClient } from '../../packages/api-client';

type Report = { id: string; status: 'open' | 'removed' | 'dismissed'; kind: string };

export function ContentReportActions({ ticketId }: { ticketId: string }) {
    const [report, setReport] = useState<Report | null>(null);
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const [decision, setDecision] = useState<'removed' | 'dismissed' | null>(null);
    useEffect(() => {
        let active = true;
        apiClient.get<{ data: Report | null }>(`/safety/tickets/${ticketId}/report`)
            .then(r => { if (active) setReport(r.data.data); })
            .catch(() => { if (active) setError('Could not load content safety actions. Reopen this ticket to retry.'); });
        return () => { active = false; };
    }, [ticketId]);
    async function resolve() {
        if (!report || !decision) return;
        setBusy(true); setError('');
        try {
            await apiClient.post(`/safety/reports/${report.id}/resolve`, { status: decision });
            setReport({ ...report, status: decision }); setDecision(null);
        } catch { setError('Could not resolve this report. It may already have been reviewed; reopen the ticket to refresh.'); }
        finally { setBusy(false); }
    }
    if (!report && !error) return null;
    return <section aria-label="Content safety review">
        <h3>Content safety review</h3>
        {error && <p role="alert">{error}</p>}
        {report && <>
            <p>Status: {report.status}. Reported {report.kind} is hidden from the reporter.</p>
            {report.status === 'open' && <>
                <button type="button" disabled={busy} onClick={() => setDecision('removed')}>Remove content for everyone</button>
                <button type="button" disabled={busy} onClick={() => setDecision('dismissed')}>Dismiss report</button>
                {decision && <div role="group" aria-label="Confirm moderation decision">
                    <p>{decision === 'removed' ? 'Hide this content from everyone? The evidence remains in this report.' : 'Dismiss this report? The content stays hidden for the reporter.'}</p>
                    <button type="button" disabled={busy} onClick={() => void resolve()}>{busy ? 'Saving…' : 'Confirm decision'}</button>
                    <button type="button" disabled={busy} onClick={() => setDecision(null)}>Cancel</button>
                </div>}
            </>}
        </>}
    </section>;
}
